import PrintDocumentsHistoryInfiniteList from './PrintDocumentsHistoryInfiniteList';
export default PrintDocumentsHistoryInfiniteList;
